<template>
    <div>
        <el-dialog
            :visible.sync="show_print"
            :append-to-body="true"
            width="70%"
            :center="true"
            top="2vh"
            :close-on-click-modal="false"
            :before-close="() => $emit('exit_print')"
        >
            <div ref="PrintStaffEntry">
                <p style="text-align: center;">
                    <b>
                        <span>{{data | title_name}}</span>
                    </b>
                </p>
                <fieldset class="fieldsetc">
                    <legend class="legendc">入职人员信息</legend>
                    <table style="font-family: Microsoft YaHei;font-size:15px;width: 100%;border: 1px solid black;">
                        <tr style="height: 40px;border: 1px solid black;">
                            <td style="width: 18%; border: 1px solid black;text-align: center;font-weight:bold;">姓名</td>
                            <td style="width: 35%; border: 1px solid black;text-align: center;">{{data.staff_name}}</td>
                            <td style="width: 18%;border: 1px solid black;text-align: center;font-weight:bold;">性别</td>
                            <td style="width: 35%;border: 1px solid black;text-align: center;">{{data.sex_name}}</td>
                        </tr>
                        <tr style="height: 40px;border: 1px solid black;">
                            <td style="width: 18%;border: 1px solid black;text-align: center;font-weight:bold;">身份证</td>
                            <td style="width: 35%;border: 1px solid black;text-align: center;">{{data.icard}}</td>
                            <td style="width: 18%;border: 1px solid black;text-align: center;font-weight:bold;">最高学历</td>
                            <td style="width: 35%;border: 1px solid black;text-align: center;">{{data.education_name}}</td>
                        </tr>
                        <tr style="height: 40px;border: 1px solid black;">
                            <td style="width: 18%;border: 1px solid black;text-align: center;font-weight:bold;">婚姻状态</td>
                            <td style="width: 35%;border: 1px solid black;text-align: center;">{{data.marriage_name}}</td>
                            <td style="width: 18%;border: 1px solid black;text-align: center;font-weight:bold;">联系电话</td>
                            <td style="width: 35%;border: 1px solid black;text-align: center;">{{data.phone}}</td>
                        </tr>
                        <tr style="height: 40px;border: 1px solid black;">
                            <td style="width: 18%;border: 1px solid black;text-align: center;font-weight:bold;">住址</td>
                            <td style="border: 1px solid black;text-align: left;white-space: pre-line;" colspan=3>{{data.address}}</td>
                        </tr>
                    </table>
                </fieldset>
                <fieldset class="fieldsetc">
                    <legend class="legendc">紧急联系人信息</legend>
                    <table style="font-family: Microsoft YaHei;font-size:15px;width: 100%;border: 1px solid black;">
                        <tr style="height: 40px;border: 1px solid black;">
                            <td style="width: 18%;border: 1px solid black;text-align: center;font-weight:bold;">紧急联系人姓名</td>
                            <td style="border: 1px solid black;text-align: center;white-space: pre-line;" colspan=3>{{data.family_name}}</td>
                        </tr>
                        <tr style="height: 40px;border: 1px solid black;">
                            <td style="width: 18%;border: 1px solid black;text-align: center;font-weight:bold;">紧急联系人关系</td>
                            <td style="border: 1px solid black;text-align: center;white-space: pre-line;" colspan=3>{{data.family_relation}}</td>
                        </tr>
                        <tr style="height: 40px;border: 1px solid black;">
                            <td style="width: 18%;border: 1px solid black;text-align: center;font-weight:bold;">紧急联系人电话</td>
                            <td style="border: 1px solid black;text-align: center;white-space: pre-line;" colspan=3>{{data.family_phone}}</td>
                        </tr>
                    </table>
                </fieldset>
                <fieldset class="fieldsetc">
                    <legend class="legendc">职位信息</legend>
                    <table style="font-family: Microsoft YaHei;font-size:15px;width: 100%;border: 1px solid black;">
                        <tr style="height: 40px;border: 1px solid black;">
                            <td style="width: 18%;border: 1px solid black;text-align: center;font-weight:bold;">入职企业</td>
                            <td style="width: 35%;border: 1px solid black;text-align: center;">{{data.entry_enterprise_name}}</td>
                            <td style="width: 18%;border: 1px solid black;text-align: center;font-weight:bold;">入职部门</td>
                            <td style="width: 35%;border: 1px solid black;text-align: center;">{{data.entry_department_name}}</td>
                        </tr>
                        <tr style="height: 40px;border: 1px solid black;">
                            <td style="width: 18%;border: 1px solid black;text-align: center;font-weight:bold;">入职职位</td>
                            <td style="width: 35%;border: 1px solid black;text-align: center;">{{data.entry_position_name}}</td>
                            <td style="width: 18%;border: 1px solid black;text-align: center;font-weight:bold;">入职职级</td>
                            <td style="width: 35%;border: 1px solid black;text-align: center;">{{data.rank_name}}</td>
                        </tr>
                        <tr style="height: 40px;border: 1px solid black;">
                            <td style="width: 18%;border: 1px solid black;text-align: center;font-weight:bold;">入职日期</td>
                            <td style="width: 35%;border: 1px solid black;text-align: center;">{{data.entry_date}}</td>
                            <td style="width: 18%;border: 1px solid black;text-align: center;font-weight:bold;">试用期限</td>
                            <td style="width: 35%;border: 1px solid black;text-align: center;">{{data.trial_time}}</td>
                        </tr>
                        <tr style="height: 40px;border: 1px solid black;">
                            <td style="width: 18%;border: 1px solid black;text-align: center;font-weight:bold;">试用薪资</td>
                            <td style="width: 35%;border: 1px solid black;text-align: center;">{{data.trial_money}}元</td>
                            <td style="width: 18%;border: 1px solid black;text-align: center;font-weight:bold;">转正薪资</td>
                            <td style="width: 35%;border: 1px solid black;text-align: center;">{{data.formal_money}}元</td>
                        </tr>
                        <tr style="height: 120px;border: 1px solid black;">
                            <td style="width: 18%;border: 1px solid black;text-align: center;font-weight:bold;">其它福利待遇</td>
                            <td style="border: 1px solid black;text-align: left;white-space: pre-line;" colspan=3>{{data.other_benefits}}</td>
                        </tr>
                        <tr style="height: 40px;border: 1px solid black;">
                            <td style="border: 1px solid black;text-align: center;font-weight:bold;">审批人</td>
                            <td style="border: 1px solid black;text-align: center;" colspan=3>{{examine}}</td>
                        </tr>
                    </table>
                </fieldset>
                <div v-for="(iteam,index) in data.print" :key="iteam.time" style="font-family: Microsoft YaHei;font-size:12px;">
                    {{'【历史】此入职登记表为第'+(index+1)+'次打印，打印人：'+iteam.staff+'，打印时间：'+iteam.time}}
                </div>
                <div style="font-family: Microsoft YaHei;font-size:12px;">
                    {{'【当前】此入职登记表为第'+(data.print.length+1)+'次打印，打印人：'+$store.state.user.name+'，打印时间：' + NowTime}}
                </div>
                <br/>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button
                    plain
                    type="primary"
                    @click="printBtn('PrintStaffEntry')"
                    >打印</el-button
                >
                <el-button
                    plain
                    @click="() => $emit('exit_print')"
                    >关闭</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { now } from '@/assets/js/common.js'
import { staff_entry_print_request  } from '@/network/hrm/StaffEntry.js'

export default {
    name:'StaffEntryPrintComponent',
    data(){
        return {
            examine: '',
            NowTime: ''
        }
    },
    computed:{},
    methods:{
        printBtn(formRef) {
            this.login_loading = true
            staff_entry_print_request(this.data.id)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$print(this.$refs[formRef])
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
    },
    filters:{
        title_name(v) {
            let a = '入职登记表：'+v.name+' '
            if(v.state === 0) {
                a += '【待提交】'
            } else if(v.state === 1) {
                a += '【审批中】'
            } else if(v.state === 2) {
                a += '【已通过】'
            } else if(v.state === 3) {
                a += '【已拒绝】'
            }

            return a
        }
    },
    props:{
        show_print: {
            type: Boolean,
            default() {
                return false
            }
        },
        data: {
            type: Object,
            default() {
                return {}
            }
        },
        ApprovalData: {
            type: Array,
            default() {
                return []
            }
        }
    },
    created(){},
    destoryed(){},
    mounted(){},
    updated(){
        this.NowTime = now()
    },
    components:{},
    watch:{
        ApprovalData(newVal) {
            this.examine = ''
            newVal.forEach(v => {
                if(v.start_staff_id) {
                    this.examine = v.start_staff_name+'(发起)'
                }
                if(v.staff_id === -1) {
                    this.examine += '→'+v.staff_name+'(撤回)'
                }
                if((v.staff_id>0) && (!v.time)) {
                    this.examine += '→'+v.staff_name+'(待审批)'
                }
                if(v.opinion) {
                    this.examine += '→'+v.staff_name+'('+v.opinion+')'
                }
                if(v.staff_id === 0) {
                    this.examine += '→流程结束'
                }
            });
        }
    }
}
</script>

<style>
</style>